import { Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function ContactSection() {
  return <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-8">
          {}
          <div className="col-span-12 lg:col-span-5 space-y-8 animate-fade-in-up">
            <div>
              <h2 className="text-4xl font-bold text-foreground mb-4">
                Get in Touch
              </h2>
              <p className="text-muted-foreground text-lg">
                Ready to transform your business operations? Contact us today to discuss how Aran Group can help you achieve your goals.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4" data-index={0}>
                <div className="flex items-center justify-center size-12 rounded-lg bg-primary/10 shrink-0">
                  <Phone className="size-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Phone</h3>
                  <p className="text-muted-foreground">(305) 342-5287</p>
                </div>
              </div>

              

              <div className="flex items-start gap-4" data-index={2}>
                <div className="flex items-center justify-center size-12 rounded-lg bg-primary/10 shrink-0">
                  <Mail className="size-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Email</h3>
                  <p className="text-muted-foreground">alvaro@arangroup.net</p>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <h3 className="font-semibold text-foreground mb-2">Business Hours</h3>
              <p className="text-muted-foreground">Mon-Fri: 9am-6pm</p>
            </div>
          </div>

          {}
          <div className="col-span-12 lg:col-span-7 animate-fade-in-up" style={{
          animationDelay: "150ms"
        }}>
            <div className="card p-8">
              <form className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div data-index={0}>
                    <label htmlFor="firstName" className="block text-sm font-medium text-foreground mb-2">
                      First Name
                    </label>
                    <input type="text" id="firstName" name="firstName" className="w-full px-4 py-2 border border-border rounded-md bg-background text-foreground focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-[var(--duration-medium)]" placeholder="John" required />
                  </div>

                  <div data-index={1}>
                    <label htmlFor="lastName" className="block text-sm font-medium text-foreground mb-2">
                      Last Name
                    </label>
                    <input type="text" id="lastName" name="lastName" className="w-full px-4 py-2 border border-border rounded-md bg-background text-foreground focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-[var(--duration-medium)]" placeholder="Doe" required />
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" className="w-full px-4 py-2 border border-border rounded-md bg-background text-foreground focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-[var(--duration-medium)]" placeholder="john.doe@example.com" required />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-foreground mb-2">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" className="w-full px-4 py-2 border border-border rounded-md bg-background text-foreground focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-[var(--duration-medium)]" placeholder="(305) 342-5287" />
                </div>

                <div>
                  <label htmlFor="service" className="block text-sm font-medium text-foreground mb-2">
                    Service Interest
                  </label>
                  <select id="service" name="service" className="w-full px-4 py-2 border border-border rounded-md bg-background text-foreground focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-[var(--duration-medium)]">
                    <option value="">Select a service</option>
                    <option value="product-launch">Product Launch & Roadmap</option>
                    <option value="efficiency-audit">Operational Efficiency Audit</option>
                    <option value="vendor-advisory">Turnkey Vendor / Procurement Advisory</option>
                    <option value="relationship-management">Account / Relationship Management Support</option>
                    <option value="technical-setup">Technical / Systems Setup & Support</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground mb-2">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={5} className="w-full px-4 py-2 border border-border rounded-md bg-background text-foreground focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none transition-all duration-[var(--duration-medium)] resize-none" placeholder="Tell us about your project or inquiry..." required />
                </div>

                <Button type="submit" size="lg" className="w-full sm:w-auto">
                  Send Message
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}